import React from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import ToggleInput from 'src/hook-form/toggle-input';

interface Props {
  rules?: any;
  name: string;
  label: string;
  required?: boolean;
  defaultValue?: string;
  helper?: string;
  items: {value: string; label: string}[];
}

const HookFormToggleInput = (props: Props) => {
  const {control} = useFormContext();

  return (
    <Controller
      control={control}
      rules={props.rules}
      render={({field}) => <ToggleInput {...props} {...field} />}
      name={props.name}
      defaultValue={props.defaultValue}
    />
  );
};

export default HookFormToggleInput;
